import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// routing
import Routes from './routes';
import {AWSCognitoProvider as AuthProvider} from 'contexts/AWSCognitoContext';
import './assets/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/css/responsive.css';
import {AppProvider} from './contexts/AppProvider';

function GTMRouteChangeTracker() {
    const location = useLocation();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.dataLayer = window.dataLayer || [];
            
            const path = location.pathname;
            let eventName = 'pageview';

            // Custom event names for "Organizaciones con Proposito"
            if (path.startsWith('/organizaciones-con-proposito')) {
                const subPath = path.replace('/organizaciones-con-proposito', '').replace(/^\//, '');
                
                let suffix = subPath;
                if (!subPath) suffix = 'home';
                if (subPath === 'sign-up') suffix = 'registro';
                
                eventName = `org-with-prop_${suffix}`;
            }

            window.dataLayer.push({
                event: eventName,
                page_path: location.pathname + location.search
            });
        }
    }, [location]);

    return null;
}

function App() {
    return (
        <AuthProvider>
            <AppProvider>
                <GTMRouteChangeTracker />
                <Routes/>
            </AppProvider>
        </AuthProvider>
    );
}

export default App;
